import lodash from 'lodash';
import { defineSelectorFactory } from '@exodus/redux-dependency-injection';
import { createSelector } from 'reselect';
const { memoize } = lodash;
const findSelectorFactory = (filterSelector) => memoize((condition = {}) => createSelector(filterSelector(condition), (filter) => {
    return filter[0];
}), (options) => JSON.stringify(options));
const findSelectorDefinition = defineSelectorFactory({
    id: 'find',
    selectorFactory: findSelectorFactory,
    dependencies: [
        { selector: 'filter' },
    ],
});
export default findSelectorDefinition;
